import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "Qualität",
  "lead": "Weltweit ist der Anteil ausgebildeter Lehrkräfte hoch, jedoch ist in den Ländern Subsahara Afrikas der Anteil der ausgebildeten Lehrkräfte von 85 % im Jahr 2000 auf 64 % im Jahr 2022 gesunken."
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Figure, HighlightByIndex, IndicatorReference, QualityFramework, RelatedMaterial, ScrollyArea, ScrollySection, ScrollySticky, Tooltip} = _components;
  if (!Figure) _missingMdxReference("Figure", true);
  if (!HighlightByIndex) _missingMdxReference("HighlightByIndex", true);
  if (!IndicatorReference) _missingMdxReference("IndicatorReference", true);
  if (!QualityFramework) _missingMdxReference("QualityFramework", true);
  if (!RelatedMaterial) _missingMdxReference("RelatedMaterial", true);
  if (!ScrollyArea) _missingMdxReference("ScrollyArea", true);
  if (!ScrollySection) _missingMdxReference("ScrollySection", true);
  if (!ScrollySticky) _missingMdxReference("ScrollySticky", true);
  if (!Tooltip) _missingMdxReference("Tooltip", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Figure, {
      id: "HERO_QUALITY"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "Gute Bildungsqualität lässt sich nicht einfach mit Lernergebnissen gleichsetzen oder darauf reduzieren. Viele Kinder haben keinen Zugang zu ausreichend ausgebildeten Lehrkräften, einer guten Schulinfrastruktur oder einem sicheren, gewaltfreien Lernumfeld."
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Es ist schwierig, die Qualität der Bildung zu überwachen, da jedes Land diese auf unterschiedliche Weise versteht und definiert. Abgesehen von den Lernergebnissen gibt es für das globale Bildungsziel SDG 4 nur wenige Indikatoren zur Messung der Qualität."
    }), "\n", _jsx(_components.h2, {
      id: "lehrkräfte",
      children: "Lehrkräfte"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.c.2",
      children: [_jsx(_components.p, {
        children: "Lehrkräfte sind der Eckpfeiler der Qualität im Bildungswesen. Nach dem Jahr 2000, als das Ziel einer allgemeinen Grundschulbildung angestrebt wurde, strömten zwar viel mehr Schüler in die Klassenzimmer, doch die Einstellung von Lehrkräften konnte mit diesem Anstieg nicht Schritt halten. Infolgedessen sind die Klassenzimmer überfüllt, was zu einer Verschlechterung der Bildungsqualität führt."
      }), _jsx(QualityFramework, {
        highlighted: "Lehrkräfte",
        description: "Erfahren Sie mehr über den Rahmen für Bildungsqualität"
      }), _jsx(_components.p, {
        children: "Die folgenden Diagramme veranschaulichen das Verhältnis zwischen Schülern und Lehrkräften in den Schulen. In einigen Ländern Subsahara Afrikas hat sich das Verhältnis seit 2000 zwar verbessert, dennoch ist das Verhältnis von Schülern zu Lehrern immer noch schlechter als in den 1980er Jahren."
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "PTR"
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["In den Ländern ", _jsx(HighlightByIndex, {
              index: "0",
              children: "Subsahara Afrikas"
            }), ", nach der Einführung der kostenlosen Grundschulbildung zwischen 1990 und 2000, wurden mehr Kinder eingeschult als Lehrkräfte eingestellt werden konnten. Die Schüler-Lehrer-Quoten stiegen infolgedessen oft recht drastisch an."]
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["Sowohl in", _jsx(HighlightByIndex, {
              index: "6",
              children: "Europa als auch in Nordamerika"
            }), " liegt das Verhältnis seit 2005 konstant bei etwa 14 Schülern pro Lehrkraft."]
          })
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: "Das Unterrichten ist eine anspruchsvolle Aufgabe, und Lehrer, die nicht gut vorbereitet sind, beginnen ihren Unterricht mit erheblichen Defiziten. Es gibt zwei Hauptmethoden, mit denen Länder messen, wie gut sie auf die Herausforderungen im Bildungsbereich vorbereitet sind. Lehrkräfte werden wie folgt beurteilt:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Erstens, ob sie  ", _jsx(_components.strong, {
          children: "qualifiziert"
        }), "sind, d. h. ob sie über die nach den nationalen Standards erwarteten akademischen Qualifikationen verfügen oder nicht."]
      }), "\n", _jsxs(_components.li, {
        children: ["Zweitens, ob sie ", _jsx(_components.strong, {
          children: "ausgebildet"
        }), "sind, wobei unabhängig von ihrer Qualifikation beurteilt wird, ob sie eine angemessene Lehrausbildung erhalten haben oder nicht."]
      }), "\n"]
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.c.1",
      children: [_jsxs(_components.p, {
        children: ["Ausbildung bedeutet, dass Lehrkräfte eine Ausbildung in ", _jsx(Tooltip, {
          title: "pädagogischem content",
          content: "Wissen über Ansätze, Methoden und Techniken des Unterrichts",
          children: "PädagogischesWissen"
        }), " und ", _jsx(Tooltip, {
          title: "beruflichescontent",
          content: "Wissen über z. B. die rechtlichen Rahmenbedingungen des Lehrerberufs erhalten haben.",
          children: "BeruflichesWissen"
        }), ". Einige Programme können auch ", _jsx(Tooltip, {
          title: "Inhaltlichecontent",
          content: "Kenntnisse des Lehrplans, des Lehrstoffs und der Verwendung relevanter Materialien.",
          children: "inhaltlicheKenntnisse"
        }), "umfassen . Die Art der erforderlichen Ausbildung variiert jedoch von Land zu Land, und es gibt nur wenige relevante Informationen dazu. Aufgrund dieser Unterschiede ist der Indikator für ausgebildete Lehrkräfte [4.c.1] einer der am wenigsten vergleichbaren im SDG-4-Überwachungsrahmen, obwohl er ein entscheidendes Element für hochwertige Bildung darstellt."]
      }), _jsxs(_components.p, {
        children: ["Weltweit ist die Mehrheit der Lehrer qualifiziert, ausgebildet oder beides. Zum Beispiel, in ", _jsx(HighlightByIndex, {
          index: "3",
          children: "Lateinamerika und in der Karibik"
        }), "haben 80 % der Lehrkräfte eine Ausbildung durchlaufen."]
      }), _jsxs(_components.p, {
        children: ["Dagegen sank in den", _jsx(HighlightByIndex, {
          index: "0",
          children: "Ländern Subsahara Afrikas"
        }), "der Prozentsatz der ausgebildeten Lehrkräfte von 85 % im Jahr 2000 auf 64 % im Jahr 2022."]
      }), _jsx(Figure, {
        id: "TRAINED"
      }), _jsx(_components.p, {
        children: "Für Länder, in denen es an qualifizierten und ausgebildeten Lehrern fehlt, gibt es keine einfache Lösung. Viele Länder haben nicht genügend qualifizierte Lehrkräfte, um den Bedarf zu decken, da die Zahl der Hochschulabsolventen insgesamt niedrig ist. Dies verdeutlicht, wie eng die Probleme innerhalb eines Bildungssystems miteinander verbunden sind: Herausforderungen auf einer Ebene, wie etwa ein niedriger Sekundarschulabschluss, können leicht Auswirkungen auf andere Bereiche haben, wie zum Beispiel den Mangel an ausgebildeten Lehrkräften für höhere Jahrgangsstufen."
      })]
    }), "\n", _jsx(_components.h2, {
      id: "infrastruktur",
      children: "Infrastruktur"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.a.1e",
      children: [_jsxs(_components.p, {
        children: ["Ein geeignetes Lernumfeld muss über ausreichende ", _jsx(_components.strong, {
          children: "Wasser"
        }), "- und Sanitäreinrichtungen verfügen, insbesondere um die Bedürfnisse von Mädchen zu berücksichtigen. Nur 53 % der Grundschulen in Ländern Subsahara Afrikas, 77 % in Ost- und Südostasien sowie 86 % in Zentral- und Südasien verfügten jedoch über Zugang zu sauberem Wasser."]
      }), _jsx(QualityFramework, {
        highlighted: "material",
        description: "Erfahren Sie mehr über den Rahmen für Bildungsqualität"
      })]
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.a.1f",
      children: [_jsxs(_components.p, {
        children: ["Insbesondere ", _jsx(_components.strong, {
          children: "Sanitäranlagen"
        }), ", denen es an Privatsphäre fehlt, können als unsicher gelten, während Einrichtungen, die keine Menstruationshygiene ermöglichen, Mädchen vom Schulbesuch abhalten können. Geschlechtergetrennte Sanitäranlagen sind daher ein entscheidender politischer Schritt, um die weit verbreitete verspätete Einschulung von Mädchen in die Grundschule und den Schulabbruch von Frauen im Laufe der Zeit zu verhindern."]
      }), _jsx(_components.p, {
        children: "Die folgende Grafik zeigt, dass nicht nur in den Ländern Subsahara Afrikas, sondern auch in asiatischen Ländern wie Afghanistan, der Demokratischen Volksrepublik Laos und Nepal weniger als die Hälfte der Grundschulen über geschlechtsspezifische sanitäre Einrichtungen verfügen. In Indonesien hatten nur 43 % der Grundschulen, 56 % der Schulen der unteren Sekundarstufe und 65 % der Schulen der oberen Sekundarstufe Zugang zu geschlechtsspezifischen Sanitäreinrichtungen."
      }), _jsx(Figure, {
        id: "SANITATION"
      })]
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.a.1a",
      children: [_jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Elektrizität"
        }), " ist ein grundlegendes Bedürfnis für ein qualitativ hochwertiges Lernumfeld, doch in vielen Ländern gibt es keinen Zugang zu Strom. In Ländern mit niedrigem Einkommen haben 73 % der Grundschulen und 58 % der Schulen der oberen Sekundarstufe keinen Zugang zu Strom."]
      }), _jsx(_components.p, {
        children: "Wie die folgende Grafik zeigt, haben in Nicaragua und Pakistan weniger als die Hälfte der Grundschulen Zugang zu Strom. In einigen Ländern Subsahara Afrikas ist der Zugang zu Elektrizität in Schulen äußerst selten: in Madagaskar haben 12 % der Schulen Strom, im Tschad nur 4 %. Ohne Strom ist die Beleuchtung möglicherweise unzureichend, und die Lehrer können Computer weder für die Verwaltung noch für den Unterricht nutzen. Ein fehlender Stromanschluss bedeutet, dass es keine Belüftung, Kühlung oder Heizung gibt, was dazu führen kann, dass die Klassenräume für den Unterricht und das Lernen ungeeignet werden."
      })]
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.a.1b",
      children: [_jsxs(_components.p, {
        children: ["Kein Strom bedeutet auch, dass die Nutzung von Technik und ", _jsx(_components.strong, {
          children: "Internet"
        }), " unmöglich ist. Strom ist jedoch nicht der einzige Faktor, der die Verbreitung des Internets bremst. In Ländern mit mittlerem Einkommen verfügten 37 % der Grundschulen und 22 % der Schulen der oberen Sekundarstufe zwar über Strom, aber nicht über Internetzugang. Selbst wenn Schulen an eine Stromquelle angeschlossen sind, kommt es häufig zu Überspannungen und Stromausfällen. Die Internetanbindung hängt von der nationalen Telekommunikationsinfrastruktur, der geografischen Lage und der finanziellen Fähigkeit der Schulen ab, den Dienst zu bezahlen."]
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "ELECTRIC"
          })
        }), _jsx(ScrollySection, {
          id: "LKA",
          children: _jsxs(_components.p, {
            children: ["In ", _jsx(_components.strong, {
              children: "Sri Lanka"
            }), " haben zwar alle Grundschulen Strom, jedoch haben nur 41 % Zugang zum Internet. Das Gleiche gilt für 34 % der Schulen in Turkmenistan und 32 % in Jordanien."]
          })
        }), _jsx(ScrollySection, {
          id: "ECU,URY",
          children: _jsxs(_components.p, {
            children: ["In vielen lateinamerikanischen Ländern gibt es Schulen, die weder über Strom noch über Internet verfügen. Nur etwa 43 % der Schulen in ", _jsx(_components.strong, {
              children: "Ecuador"
            }), " und 63 % der Schulen in Argentinien können behaupten, Zugang zu beidem – Strom und Internet – zu haben. Eine Ausnahme ist ", _jsx(_components.strong, {
              children: "Uruguay"
            }), ", wo 100 % der Grundschulen Zugang zu beidem haben."]
          })
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "gewalt",
      children: "Gewalt"
    }), "\n", _jsx(_components.p, {
      children: "Gewalttätige Handlungen oder Drohungen im schulischen Kontext können psychischer, physischer oder sexueller Natur sein und sowohl auf dem Schulgelände als auch auf dem Schulweg, zu Hause oder im Cyberspace vorkommen. Sie entstehen häufig aufgrund unausgeglichener Machtdynamiken und sind oft das Ergebnis negativer Geschlechternormen und -stereotypen."
    }), "\n", _jsx(_components.p, {
      children: "Während die Aufmerksamkeit oft auf extreme Ereignisse wie Schießereien gerichtet ist, sind es die häufigeren und oft unbemerkten Formen von Gewalt, wie Mobbing, die die größten negativen Auswirkungen auf die Bildung von Kindern und Jugendlichen haben. Die Daten zu diesen Themen sind nach wie vor unzureichend, da bei der Datenerhebung unterschiedliche Definitionen von gewalttätigem Verhalten, verschiedene Berichtszeiträume, nicht vergleichbare Antwortmöglichkeiten sowie unterschiedliche Datenschutzregelungen und ethische Protokolle berücksichtigt werden. Hinzu kommt, dass auch Formen von Gewalt wie homophobes Mobbing, die oft mit Tabus behaftet sind, zu wenig gemeldet werden."
    }), "\n", _jsx(QualityFramework, {
      highlighted: "school",
      description: "Erfahren Sie mehr über den Rahmen für Bildungsqualität"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.a.2",
      children: [_jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Mobbing"
        }), " ist die am häufigsten dokumentierte Form von Gewalt in Schulen. Mobbing kann körperliche Gewalt, verbale Beschimpfungen und die Absicht beinhalten, psychischen Schaden durch Demütigung oder Ausgrenzung zu verursachen. Die folgende Abbildung zeigt, dass in den meisten Ländern mindestens einer von drei Jugendlichen, wobei häufig mehr Jungen als Mädchen betroffen sind, Opfer von Mobbing wird."]
      }), _jsx(Figure, {
        id: "BULLY_FIGHT"
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Physische Gewalt"
      }), " umfasst die Beteiligung an körperlichen Auseinandersetzungen in der Schule, das Tragen von Waffen wie einer Pistole, einem Messer oder einem Schlagstock auf dem Schulgelände, die Bedrohung mit solchen Waffen, die Zugehörigkeit zu einer Bande oder das Erleiden körperlicher Gewalt durch ein Mitglied des Schulpersonals."]
    }), "\n", _jsx(_components.p, {
      children: "Mindestens 10 % der 15-jährigen Jungen in 24 Ländern gaben an, im Jahr 2022 dreimal oder öfter in körperliche Auseinandersetzungen verwickelt gewesen zu sein. In Armenien lag die Prävalenz sogar bei über 30 %."
    }), "\n", _jsx(_components.h2, {
      id: "schlussfolgerung",
      children: "Schlussfolgerung"
    }), "\n", _jsx(_components.p, {
      children: "Gleichzeitig sind international vergleichbare Daten zu Lehrindikatoren überraschend selten. Nur wenige Länder melden überhaupt eine einfache Anzahl von Lehrern, wobei komplexe Aspekte wie Unterrichtsstunden, Lehrer in Verwaltungspositionen und andere Faktoren nicht berücksichtigt werden. Es ist notwendig, eine Typologie der Standards für ausgebildete Lehrer zu entwickeln, um die bestehenden Lücken genau zu identifizieren und dieses Thema auf globaler Ebene anzusprechen."
    }), "\n", _jsx(_components.p, {
      children: "Wie dieser Artikel zeigt, stellt die Bereitstellung von \"kinder-, behinderten- und geschlechtersensiblen\" Bildungseinrichtungen sowie von \"sicheren, gewaltfreien, integrativen und effektiven Lernumgebungen für alle\" in vielen Ländern eine erhebliche Herausforderung dar. Es ist jedoch schwierig, die Fortschritte in diesem Bereich zu messen, da der relevante globale Indikator nicht aus einem einzelnen Maß besteht, sondern mehrere Dimensionen umfasst."
    }), "\n", _jsx(RelatedMaterial, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://www.oecd-ilibrary.org/education/education-at-a-glance_19991487",
            children: "Education at a glance – OECD"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://theirworld.org/news/safe-schools-report-reveals-crises-challenges-action-needed-to-educate-children",
            children: "Safe Schools Report – Their World"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://unesdoc.unesco.org/ark:/48223/pf0000232107",
            children: "School-related gender-based violence is preventing the achievement of quality education for all"
          })
        }), "\n"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
